import React from 'react';
import {
  IconConnectedApps,
  IconGroup,
  IconNote,
  IconProps,
  IconReportsAvgGlucose,
  SideNavigation,
  SideNavigationProps,
} from '@adc/parallax-component-library';
import { IconPhosphorAddressBookTabsRegular } from '@adc/parallax-icons/phosphor';
import './SideNav.scss';
import { useNavigate } from 'react-router';
import i18n from '../../utilities/i18n';
import { useAppSelector } from '../../reducers/hooks';

export default function SideNav() {
  const navigate = useNavigate();

  const capabilities = useAppSelector((state) => state.capabilities);

  const navItems: SideNavigationProps['items'] = [];

  const iconProps = {
    size: 'XS' as IconProps['size'],
    color: '$text.80' as IconProps['color'],
  };

  if (capabilities.canGetStudyData) {
    navItems.push({
      label: i18n.t('SideNavigation.dashboard'),
      key: 'dashboard',
      icon: <IconReportsAvgGlucose {...iconProps} />,
    });
  }

  if (capabilities.canGetStudies) {
    navItems.push({
      label: i18n.t('SideNavigation.studies'),
      key: 'studies',
      icon: <IconNote {...iconProps} />,
    });
  }

  if (capabilities.canGetOrganizations) {
    navItems.push({
      label: i18n.t('SideNavigation.organizations'),
      key: 'organizations',
      icon: <IconConnectedApps {...iconProps} />,
    });
  }

  if (capabilities.canGetUsers) {
    navItems.push({
      label: i18n.t('SideNavigation.manageUsers'),
      key: 'accounts',
      icon: <IconGroup {...iconProps} />,
    });
  }

  if (capabilities.canGetAssignments) {
    navItems.push({
      label: i18n.t('SideNavigation.roleAssignments'),
      key: 'role-assignments',
      icon: <IconPhosphorAddressBookTabsRegular {...iconProps} />,
    });
  }

  return navItems.length > 0 ? (
    <div className="side-navigation">
      <SideNavigation
        height="100%"
        items={navItems}
        onItemSelected={(key) => navigate(`/${key}`)}
        testID="side-nav"
      />
    </div>
  ) : null;
}
